import { render, staticRenderFns } from "./CustomerSalesService.vue?vue&type=template&id=09db6856&scoped=true&"
import script from "./CustomerSalesService.vue?vue&type=script&lang=js&"
export * from "./CustomerSalesService.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSalesService.vue?vue&type=style&index=0&id=09db6856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db6856",
  null
  
)

export default component.exports